mainApp.directive('entityFilter', function() {
    return {
        templateUrl: '/public/directives/entityFilter.html',
        scope: {
            type: "=",
            pid: "=",
            back: "=",
            remove: "=",
            change: "=",
            options: "=",
            currentPage: "=",
            parentPage: "=",
            currentTab: "=",
            hideAll: "=?"
        },
        controller: ["$scope", "$state", "$timeout", function ($scope, $state, $timeout) {
            $scope.curerentFilter = angular.fromJson($state.params.filter);
            $scope.filterType = $scope.curerentFilter ? ($scope.curerentFilter.type + "s") : "sites";
            $scope.selectedFilter = null;
            $scope.lockFilterType = false;
            $scope.retrievedData = false;
            getLoginsData();

            var dataConfig = {"dateField":"","fromDate":0,"toDate":0,"from":0,"limit":-1,"search":"","searchField":"name","orders":[{"path":"name","dir":"ASC"}]};

            $scope.entityCounters = {
                sites:{
                    total: 0,
                    online: 0
                },
                logins:{
                    total: 0,
                    online: 0
                }
            };

            if(!$scope.pid && $scope.pid !== 0){
                getEntities();
            }

            function getLoginsData(){
                store.fetch({
                    method: 'POST',
                    data: dataConfig,
                    dataObj: 'dataConfig',
                    path: "/getAllLogins?accountId=" + ($state.params.accountId ? $state.params.accountId : ""),
                    success: function (data) {
                        $scope.$apply(function(){
                            if(data && data.items) {
                                $scope.loginsData = data.items;
                            }
                        });
                    }
                });
            }

            $scope.getNameAndEmail = function(){
                var nameAndEmail;
                angular.forEach($scope.loginsData, function(login) {
                    if(angular.equals(login.protoId, $scope.curerentFilter.pid)){
                        nameAndEmail = login.name + " (" + login.email + ")";
                    }
                });
                return nameAndEmail ? nameAndEmail : $scope.curerentFilter.name;
            }

            $scope.$watch("filterType", function(newVal, oldVal){
                if(newVal !== oldVal){
                    $scope.selectedFilter = {};
                    $scope.selectedFilter = $scope.curerentFilter;
                    if(!$scope[$scope.filterType]){
                        getEntities($scope.filterType);
                    } else {
                        $timeout(function() {
                            $scope.updateScroll();
                        }, 0, false);
                    }
                }
            });

            $scope.$watch("searchEntities", function(newVal, oldVal){
                if(newVal !== oldVal){
                    $scope.updateScroll();
                }
            });

            function getEntities(type) {
                if (!type || type === "sites") {
                    dataConfig.type = "Site";
                    store.fetch({
                        method: 'POST',
                        data: dataConfig,
                        dataObj: 'dataConfig',
                        path: "/getAllSites?accountId=" + ($state.params.accountId? $state.params.accountId : ""),
                        success: function(data){
                            $scope.$apply(function() {
                                if (data && data.items) {
                                    $scope.sites = data.items;
                                    $scope.entityCounters.sites.total = data.total;
                                    $scope.retrievedData = true;
                                }
                            });

                            $scope.updateScroll();
                        }
                    });
                }

                if(!type || type === "logins"){
                    dataConfig.type = "AccessLogin";
                    store.fetch({
                        method: 'POST',
                        data: dataConfig,
                        dataObj: 'dataConfig',
                        path: "/getAllLogins?accountId=" + ($state.params.accountId ? $state.params.accountId : ""),
                        success: function (data) {
                            $scope.$apply(function(){
                                if(data && data.items) {
                                    $scope.logins = data.items;
                                    $scope.entityCounters.logins.total = data.total;
                                    $scope.retrievedData = true;
                                }
                            });

                            $scope.updateScroll();
                        }
                    });
                }
            }

            store.fetch({
                path: "/getAccountEntitiesCounts?accountId=" + ($state.params.accountId? $state.params.accountId : ""),
                success: function(data) {
                    $scope.entityCounters.sites.online = data.sitesActive;
                    $scope.entityCounters.logins.online = data.accessloginsActive;
                }
            });

            $scope.setCurrent = function(row){
                if(!row || ($scope.curerentFilter && $scope.curerentFilter.pid === row.protoId)){
                    if(($scope.curerentFilter && row && $scope.curerentFilter.pid === row.protoId) && $scope.hideAll){
                        return;
                    }
                    $state.go($state.current.name, {
                        filter: null
                    });
                }
                else {
                    var monitoringFilter = {
                        pid: row.protoId,
                        name: row.name,
                        type: (row.type == 'SITE'?'site':'login')
                    };

                    $state.go($state.current.name, {
                        filter: angular.toJson(monitoringFilter)
                    });
                }
            };

            $scope.openFilterDlg = function(targetElId) {
                $scope.$emit("$openPopup","filterOptions",targetElId , {"topMod":-40,"leftMod":-90,lockDown:false} );

                $('#' + targetElId).addClass('open');

                $scope.selectedFilter = {};
                $scope.selectedFilter = $scope.curerentFilter;

                if(!$scope[$scope.filterType]){
                    getEntities($scope.filterType);
                }
                else {
                    $scope.updateScroll();
                }
            };


            $scope.updateScroll = function(){
                $scope.$root.updateScroll('#filterOptions .nano');
            };

            $scope.closeFilterDlg = function(targetElId) {
                $scope.$emit("$closePopup","filterOptions");
                $('#' + targetElId).removeClass('open');
            };

            $scope.toggleFilterDlg = function(targetElId, targetType){
                if(targetType){
                    $scope.filterType = targetType;
                    $scope.lockFilterType = true;
                }
                else {
                    $scope.lockFilterType = false;
                }

                if($('#' + targetElId).css('display') === 'block'){
                    $scope.closeFilterDlg(targetElId);
                }
                else{
                    $scope.openFilterDlg(targetElId);
                }
            };

            $scope.changePid = function(){
                $scope.removeURLFilters();
            };

            $scope.toggleFilter = function(){
                var targetType;
                if($scope.currentPage === "Site"){
                    targetType = "sites";
                }
                else if($scope.currentPage === "Users") {
                    targetType = "logins";
                }

                $scope.toggleFilterDlg('change-filter', targetType);
            };

            $scope.removeURLFilters = function(){
                switch ($scope.type) {
                    case "sites":
                        $state.go('app.monitorSites');
                        break;
                    case "logins":
                        $state.go('app.monitorLogins');
                        break;
                }
            };

            $scope.backPID = ($scope.type === "sites" || $scope.type === "logins")? $scope.removeURLFilters : null;

            $scope.removePID = ($scope.type === "sites" || $scope.type === "logins" || !($scope.pid || $scope.pid === 0))? null : function(){
                var monitoringFilter = $scope.curerentFilter;
                if(monitoringFilter && (monitoringFilter.pid || monitoringFilter.pid == 0)){
                    $scope.removeFilter();
                }
            };

            $scope.$on('destroy', function(){
                $scope.closeFilterDlg();
            });
        }]
    }
});